// Custom events for Simple Analytics, next to the page views it collects (shared/_analytics). Its
// script only runs in production and ad blockers often stop it, so without sa_event this does nothing.
// Metadata is about the listing or guide, never the visitor.

export function trackEvent(name, metadata = {}, element = null) {
  try {
    if (typeof window.sa_event !== "function" || doNotTrack()) return

    const guide = (element?.closest?.("[data-sa-guide]") || document.querySelector("[data-sa-guide]"))?.dataset.saGuide
    window.sa_event(name, clean({ guide, ...metadata }))
  } catch (error) {
    // Analytics must never get in the way of the click
  }
}

// Simple Analytics sends nothing when Do Not Track is on, so neither does this (its queued events
// would be dropped anyway)
function doNotTrack() {
  return "doNotTrack" in navigator && navigator.doNotTrack == "1"
}

// Simple Analytics takes text, numbers and booleans, and refuses empty strings and nulls
function clean(metadata) {
  const kept = {}
  for (const [key, value] of Object.entries(metadata)) {
    if (value === undefined || value === null || value === "") continue
    if (key.endsWith("_id") && /^\d+$/.test(value)) kept[key] = Number(value)
    else if (["string", "number", "boolean"].includes(typeof value)) kept[key] = value
  }
  return kept
}

// Links name their event in data-sa-event and their metadata in data-sa-meta-* (AnalyticsHelper). The
// event is fired as the click starts, before the browser follows the link; those leaving the site
// open in a new tab, and the rest are Turbo visits or downloads, so the page stays to send it.
function trackLink(event) {
  const link = event.target.closest?.("a[data-sa-event]")
  if (!link || (event.type === "auxclick" && event.button !== 1)) return

  const metadata = {}
  for (const [key, value] of Object.entries(link.dataset)) {
    if (key.startsWith("saMeta") && key.length > 6) metadata[snakeCase(key.slice(6))] = value
  }
  trackEvent(link.dataset.saEvent, metadata, link)
}

function snakeCase(key) {
  return key.replace(/^[A-Z]/, letter => letter.toLowerCase()).replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)
}

addEventListener("click", trackLink, { capture: true })
addEventListener("auxclick", trackLink, { capture: true })
